module.exports = __webpack_public_path__ + "static/media/Miami soffa tyg siri grön 06 detalj 2023 3.e5456a69.jpg";